function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.753 5.069a.499.499 0 00-.496-.006L21 9.65V6.7c0-1.017-.638-1.7-1.587-1.7H3.136C1.077 5 0 10.031 0 15s1.077 10 3.136 10h16.277c.949 0 1.587-.683 1.587-1.7v-2.95l8.257 4.587a.498.498 0 00.496-.006A.5.5 0 0030 24.5v-19a.5.5 0 00-.247-.431z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "5",
  width: "30",
  height: "20"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.753 5.069a.499.499 0 00-.496-.006L21 9.65V6.7c0-1.017-.638-1.7-1.587-1.7H3.136C1.077 5 0 10.031 0 15s1.077 10 3.136 10h16.277c.949 0 1.587-.683 1.587-1.7v-2.95l8.257 4.587a.498.498 0 00.496-.006A.5.5 0 0030 24.5v-19a.5.5 0 00-.247-.431z",
  fill: "currentColor"
}))));